import { createSelector } from 'reselect';

import { periodSelector } from '../../../reducers/selectors';

const currentPeriodSelector = createSelector(
  periodSelector,

  period => {
    let status = false;
    if (period) {
      const periodStartDate = period.startDate;
      const periodEndDate = period.endDate;
      const dateNow = new Date(Date.now());
      if (periodStartDate < dateNow && dateNow < periodEndDate) {
        status = true;
      }
    }

    return status;
  },
);

export default currentPeriodSelector;
